import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Modal, Tag } from 'antd';

import './index.scss';

import { IMG_CHAT_INTERFACE } from '../../../../data/assets/img';
import { METHOD_TYPES } from '../../../../data/config/constants';
import { log, showMessage, scrollToBottom, downloadChatlogTranscript } from '../../../../data/config/utils';

import ChatHeader from './components/chatheader';
import ChatBody from './components/chatbody';
import ChatComposer from './components/chatcomposer';
import Insight from './components/insight';
import ErrorBoundary from '../../../../components/errorboundary';

export default class ChatInterface extends Component {
  constructor(props) {
    super(props);
    this.chatContainer = null;
    this.state = {
      show_insight: false,
      modal_title: null,
      active_popup_message: null
    };
  }

  componentDidMount() {
    scrollToBottom(this.chatContainer);
  }

  setChatBodyRef = element => { this.chatBodyRef = element; };

  setChatContainerRef = element => { this.chatContainer = element; };

  editMessageNLPSnapshot = message => {
    const { active_chat_item } = this.props;
    if (active_chat_item && active_chat_item.isTrainingAllowedOnMessages) {
      this.setState({
        show_insight: active_chat_item.isTrainingAllowedOnMessages,
        modal_title: "INSIGHTS",
        active_popup_message: message
      });
    } else {
      showMessage('warning', 'Traning is not allowed for this channel.')
    }
  };

  updateMessageIntent = data => {
    const { active_popup_message } = this.state;
    this.setState({
      active_popup_message: {
        ...active_popup_message,
        NLPSnapshot: {
          ...active_popup_message.NLPSnapshot,
          intentSnapshot: {
            ...active_popup_message.NLPSnapshot.intentSnapshot,
            intent: data
          }
        }
      }
    });
  };

  addEntity = entity => {
    const { active_popup_message } = this.state;
    this.setState({
      active_popup_message: {
        ...active_popup_message,
        NLPSnapshot: {
          ...active_popup_message.NLPSnapshot,
          entitySnapshot: [...active_popup_message.NLPSnapshot.entitySnapshot, entity]
        }
      }
    });
  };

  updateEntityType = (data, index) => {
    const { active_popup_message } = this.state;
    const selected_entity_type = JSON.parse(data);
    log('selected type value', selected_entity_type);
    const updated_entity = {
      ...active_popup_message.NLPSnapshot.entitySnapshot[index],
      ...selected_entity_type,
    };
    this.setState({
      active_popup_message: {
        ...active_popup_message,
        NLPSnapshot: {
          ...active_popup_message.NLPSnapshot,
          entitySnapshot: [...active_popup_message.NLPSnapshot.entitySnapshot.slice(0, index), updated_entity, ...active_popup_message.NLPSnapshot.entitySnapshot.slice(index + 1)]
        }
      }
    });
  };

  deleteEntity = index => {
    const { active_popup_message } = this.state;
    this.setState({
      active_popup_message: {
        ...active_popup_message,
        NLPSnapshot: {
          ...active_popup_message.NLPSnapshot,
          entitySnapshot: [...active_popup_message.NLPSnapshot.entitySnapshot.slice(0, index), ...active_popup_message.NLPSnapshot.entitySnapshot.slice(index + 1)]
        }
      }
    });
  };

  closeModal = () => {
    this.setState({
      show_insight: false,
      modal_title: null,
      active_popup_message: null
    });
  };

  downloadChatlogs = () => {
    const { active_chat_item, messages } = this.props;
    if (this.chatBodyRef && active_chat_item && active_chat_item.psid)
      downloadChatlogTranscript({
        filename: `chatlogs-${active_chat_item.psid}/${active_chat_item.sessionId ? active_chat_item.sessionId : ''}.pdf`,
        messages
      })
  };

  render() {
    const { show_insight, modal_title, active_popup_message } = this.state;
    const { messages, active_chat_item, typing_info, onClickTransfer, onClickClose, isActionPermitted, handleChatEvent, show_chat_composer, show_composer_type, handleMessageSend, sendTypingIndication, tags, selected_tags, tags_loading, updateSelectedTag, show_customer_votes } = this.props;
    return (
      <div className="ori-bg-default ori-full-width ori-full-parent-height ori-flex-column oriChatInterfaceContainer" style={{ backgroundImage: `url(${IMG_CHAT_INTERFACE})` }}>
        <div className="chatHeaderContainer">
          <ChatHeader
            active_chat_item={active_chat_item}
            onClickTransfer={onClickTransfer}
            onClickClose={onClickClose}
            onClickDownloadChatlogs={this.downloadChatlogs}
            handleChatEvent={handleChatEvent}
          />
        </div>
        <div className="ori-full-flex ori-b-pad-40 chatBodyContainer" ref={this.setChatContainerRef}>
          <ChatBody
            setChatBodyRef={this.setChatBodyRef}
            active_chat_item={active_chat_item}
            typing_info={typing_info}
            chatContainer={this.chatContainer}
            messages={messages}
            editMessageNLPSnapshot={this.editMessageNLPSnapshot}
            show_customer_votes={show_customer_votes}
          />
        </div>
        <div className="ori-lr-pad-15 ori-b-pad-15">
          {
            show_chat_composer &&
            <ErrorBoundary>
              <React.Fragment>
                {
                  selected_tags.length > 0 &&
                  <div className="ori-t-pad-5">
                    {
                      selected_tags.map(tag => (
                        <Tag key={tag._id} className="ori-b-mrgn-5 ori-animated ori-fade-in" color="orange" onClose={updateSelectedTag.bind(this, { tag, clientPsid: active_chat_item.psid }, METHOD_TYPES.DELETE)} closable visible>{tag.name}</Tag>
                      ))
                    }
                  </div>
                }
                <ChatComposer active_chat_item={active_chat_item} handleMessageSend={handleMessageSend} show_composer_type={show_composer_type} sendTypingIndication={sendTypingIndication} tags={tags} tags_loading={tags_loading} updateSelectedTag={updateSelectedTag} />
              </React.Fragment>
            </ErrorBoundary>
          }
        </div>
        <Modal className={classNames("ori-modal-primary", { "insightSpecificModalClass": show_insight })} visible={show_insight} title={modal_title} footer={null} maskClosable={false} onCancel={this.closeModal}>
          {
            show_insight &&
            <Insight psid={active_chat_item.psid} isActionPermitted={isActionPermitted} active_popup_message={active_popup_message} closeModal={this.closeModal} updateMessageIntent={this.updateMessageIntent} addEntity={this.addEntity} updateEntityType={this.updateEntityType} deleteEntity={this.deleteEntity} />
          }
        </Modal>
      </div>
    );
  }
}

ChatInterface.propTypes = {
  isActionPermitted: PropTypes.func.isRequired,
  active_chat_item: PropTypes.object,
  typing_info: PropTypes.object,
  messages: PropTypes.array.isRequired,
  downloadHtmlNodePdf: PropTypes.func,
  onClickTransfer: PropTypes.func,
  onClickClose: PropTypes.func,
  show_chat_composer: PropTypes.bool,
  show_composer_type: PropTypes.bool,
  handleMessageSend: PropTypes.func,
  handleChatEvent: PropTypes.func,
  tags: PropTypes.array,
  selected_tags: PropTypes.array,
  updateSelectedTag: PropTypes.func,

  addSelectedTag: PropTypes.func,
  removeSelectedTag: PropTypes.func,
  tags_loading: PropTypes.bool,
  sendTypingIndication: PropTypes.func,
  show_customer_votes: PropTypes.bool,
};

ChatInterface.defaultProps = {
  show_chat_composer: false,
  tags: [],
  selected_tags: [],
  tags_loading: false,
  show_customer_votes: false,
};



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/chatinterface/index.js